/* eslint-disable @typescript-eslint/ban-ts-comment */
import { ICategory } from "web/types/Category";
import { Nullable } from "web/types/Utils";

const findStartCategoryData = (
  categoriesData: ICategory[],
  startCategoryId: Nullable<number>
): ICategory | null => {
  const initialStartCategoryId = startCategoryId === 2 ? null : startCategoryId;

  return initialStartCategoryId
    ? // @ts-ignore
      categoriesData.find((category) => +category.id === +startCategoryId)
    : null;
};

export default findStartCategoryData;
